<template>
  <div class="staticBook-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span v-if="$route.query.id">编辑预装书</span>
        <span v-else>新增预装书</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'staticBook' })"
        >
          {{ $t("commonMsg.back") }}
        </button>
        <button class="global-button-style" @click="save">
          {{ $t("commonMsg.save") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container"
      :body-style="{ padding: '20px' }"
      v-bar
    >
      <div class="body-wrap">
        <el-form
          label-width="100px"
          @submit.native.prevent
          :model="formData"
          ref="ruleForm"
          label-position="top"
          :rules="rules"
        >
          <el-form-item label="封面" class="pic">
            <div class="pic-item">
              <div class="staticBook-edit-cover">
                <img v-if="cover" :src="cover" />
                <i v-else class="staticBook-edit-cover-icon el-icon-plus"></i>
                <div class="staticBook-edit-upload">
                  <el-upload
                    class="staticBook-edit-upload-btn"
                    action
                    :accept="'image/*'"
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleCoverChange"
                  >
                    <div v-if="cover" class="staticBook-upload-icon">
                      替换
                    </div>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="文件" class="pic">
            <div class="pic-item">
              <div>
                <span v-if="fileName">{{ fileName }}</span>
                <div>
                  <el-upload
                    action
                    :auto-upload="false"
                    :show-file-list="false"
                    :on-change="handleFileChange"
                  >
                    <button class="global-button-style">上传文件</button>
                  </el-upload>
                </div>
              </div>
            </div>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="formData.title"></el-input>
          </el-form-item>
          <el-form-item label="型号(多种型号用\隔开)" prop="model">
            <el-input v-model="formData.model"></el-input>
          </el-form-item>
          <el-form-item label="设备型号组" prop="modelGroups">
            <el-checkbox-group v-model="formData.modelGroups">
              <el-checkbox
                v-for="item in modelData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="语言(多种语言用\隔开)" prop="lang">
            <el-input v-model="formData.lang"></el-input>
          </el-form-item>
          <el-form-item label="语言组" prop="langGroups">
            <el-checkbox-group v-model="formData.langGroups">
              <el-checkbox
                v-for="item in langData"
                :key="item._id"
                :label="item._id"
                >{{ item.name }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import OSS from "ali-oss";
export default {
  computed: {
    ...mapGetters(["buckets"])
  },
  data() {
    return {
      formData: {
        model: "",
        modelGroups: [],
        lang: "",
        langGroups: [],
        title: "",
        cover: {},
        file: {}
      },
      params: {},
      modelData: [],
      langData: [],
      rules: {
        // pic_address: [
        //   { required: true, message: "请选择广告封面", trigger: "change" }
        // ]
      },
      fileName: null,
      cover: null,
      dataForm: null
    };
  },
  methods: {
    async handleCoverChange(file, filtList) {
      let ossFile = await this.uploadOss(file, "cover");
      this.formData.cover = {
        size: file.size,
        name: file.name,
        key: ossFile.name,
        bucket: ossFile.bucket,
        url: ossFile.res.requestUrls[0].split("?")[0]
      };
      this.cover = ossFile.res.requestUrls[0].split("?")[0];
    },

    async handleFileChange(file, filtList) {
      let ossFile = await this.uploadOss(file, "book");
      this.formData.file = {
        size: file.size,
        name: file.name,
        key: ossFile.name,
        bucket: ossFile.bucket,
        url: ossFile.res.requestUrls[0].split("?")[0]
      };
      this.fileName = file.name;
    },

    async uploadOss(file, type) {
      let { bucket, region } = this.buckets["onyx-static"];
      let randomName =
        this.random_string(6) +
        "_" +
        new Date().getTime() +
        "." +
        file.name.split(".").pop();
      return new Promise(async (resolve, reject) => {
        try {
          let sts = await this.$http.aliyunSts();
          let client = await new OSS({
            region,
            accessKeyId: sts.data.AccessKeyId,
            accessKeySecret: sts.data.AccessKeySecret,
            stsToken: sts.data.SecurityToken,
            bucket
          });
          let coverData = await client.multipartUpload(
            `device/static/${type}/${randomName}`,
            file.raw
          );
          resolve(coverData);
        } catch (error) {
          reject(error);
        }
      });
    },

    random_string(len) {
      len = len || 32;
      var chars = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678";
      var maxPos = chars.length;
      var pwd = "";
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos));
      }
      return pwd;
    },

    getStaticBookDetails() {
      this.$http.getStaticBookDetails(this.$route.query.id).then(res => {
        res.data.model = res.data.model.join("\\");
        res.data.lang = res.data.lang.join("\\");
        this.formData = Object.assign(this.formData, res.data);
        this.cover = res.data.cover.url;
        this.fileName = res.data.file.name;
      });
    },

    getModelGroups() {
      this.$http.getModelGroups().then(res => {
        this.modelData = res.data.results;
      });
    },
    getLangGroups() {
      this.$http.getLangGroups().then(res => {
        this.langData = res.data.results;
      });
    },

    save() {
      if (!this.cover) {
        this.elMsg("请添加封面", "error");
        return;
      }

      if (!this.fileName) {
        this.elMsg("请上传文件", "error");
        return;
      }

      this.params = Object.assign({}, this.formData);
      this.params.model = this.params.model.split("\\");
      this.params.lang = this.params.lang.split("\\");

      if (this.$route.query.id) {
        this.edit();
      } else {
        this.create();
      }
    },

    create() {
      this.$http.createStaticBook(this.params).then(res => {
        this.elMsg("添加成功", "success");
        this.$router.push({ name: "staticBook" });
      });
    },

    edit() {
      if (this.file) {
        this.params["file"] = this.file;
      }

      this.$http
        .updateStaticBook(this.$route.query.id, this.params)
        .then(res => {
          this.elMsg("编辑成功", "success");
          this.$router.push({ name: "staticBook" });
        });
    }
  },
  mounted() {
    this.getModelGroups();
    this.getLangGroups();
    if (this.$route.query.id) {
      this.getStaticBookDetails();
    }
  }
};
</script>

<style lang="scss">
.staticBook-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .body-wrap {
    /* height: 100%; */
    flex: 1;
    overflow: hidden;
    .el-form {
      width: 80%;
      margin: 10px auto;
      .global-button-style {
        width: 100%;
        margin: 0;
      }
    }
    .pic {
      .pic-item {
        /* position: relative; */
        display: flex;
        flex-direction: column;
        overflow: hidden;
      }
      .global-button-style {
        width: 80px;
        height: 30px;
      }
      .staticBook-edit-cover {
        position: relative;
        width: 200px;
        height: 300px;
        overflow: hidden;
        margin: 10px 0;
        border: 2px dashed #ccc;
        border-radius: 10px;
        &:hover {
          border-color: #bb745c;
        }
        > img {
          width: 100%;
          height: 100%;
        }
        > .staticBook-edit-cover-icon {
          font-weight: bold;
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          color: #bb745c;
        }
        > .staticBook-edit-upload {
          width: 100%;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          transition: all 0.2s;
          &:hover {
            transition: all 0.2s;
            background: rgba($color: #000000, $alpha: 0.4);
            .staticBook-edit-upload-btn {
              display: block;
            }
          }
          .staticBook-edit-upload-btn {
            width: 100%;
            height: 100%;
            display: none;
            cursor: pointer;
            color: #fff;
            font-weight: bold;
            position: absolute;
            text-align: center;
            line-height: 300px;
            > .el-upload--text {
              width: 100%;
              height: 100%;
            }
          }
        }
      }
      .add-img {
        width: 70px;
        height: 40px;
        font-size: 22px;
        line-height: 43px;
        color: #fff;
        cursor: pointer;
        background-color: #bb745c;
      }
    }
  }
}
</style>
